<template>
    <div>
        <p v-text="text"></p>
        <v-radio-group v-model="selected">
            <v-radio
                    v-for="item in items"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
            ></v-radio>
        </v-radio-group>
        <v-btn color="primary" :disabled="disable || selected === null" @click="handleSubmitQuestion">Submit</v-btn>
    </div>
</template>
<script>
    export default {
        name: 'GroupSingleQuestion',
        methods: {
            handleSubmitQuestion() {
                this.disable = true;
                this.$emit('evidenceDefined', {id: this.selected, choice_id: "present"});
            }
        },
        watch: {
            text() {
                this.selected = null;
                this.disable = false;
            }
        },
        props: ['text', 'items'],
        data: () => ({
            selected: null,
            disable: false,
        }),
    }
</script>